'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _animation_tks = require('./animation_tks.gif');

var _animation_tks2 = _interopRequireDefault(_animation_tks);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Thanks = function (_Component) {
  (0, _inherits3.default)(Thanks, _Component);

  function Thanks() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Thanks);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Thanks.__proto__ || (0, _getPrototypeOf2.default)(Thanks)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      redirect: false
    }, _this.handleClick = function () {
      _this.setState({ redirect: true });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Thanks, [{
    key: 'render',
    value: function render() {
      var styles = require('./Partner.scss');
      var redirect = this.state.redirect;

      if (redirect) {
        _reactRouter.browserHistory.push('/');
      }
      return _react2.default.createElement(
        'div',
        { className: styles.container2 },
        _react2.default.createElement('img', { src: _animation_tks2.default, alt: '', className: styles.thanksImage }),
        _react2.default.createElement(
          'div',
          { className: styles.gratefulness },
          'C\xE1m \u01A1n b\u1EA1n \u0111\xE3 \u0111\u0103ng k\xED tr\u1EDF th\xE0nh \u0111\u1ED1i t\xE1c c\u1EE7a',
          ' ',
          _react2.default.createElement(
            'span',
            { className: styles.hightlight },
            'LOOKME'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.normal },
          'Ch\xFAng t\xF4i s\u1EBD s\u1EDBm li\xEAn l\u1EA1c l\u1EA1i v\u1EDBi b\u1EA1n'
        ),
        _react2.default.createElement(
          'button',
          { className: styles.button, onClick: this.handleClick },
          'Quay v\u1EC1 trang ch\u1EE7'
        )
      );
    }
  }]);
  return Thanks;
}(_react.Component);

exports.default = Thanks;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PartnerRegistration/Thanks.js
// module id = 1683
// module chunks = 0